var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-main"},[_c('div',{staticClass:"content-wrap"},[_c('section',{staticClass:"content-section"},[_c('article',[_c('div',{staticClass:"widget-container",attrs:{"id":"Finvia-widgets"}})])])])])
}]

export { render, staticRenderFns }